<app-menu></app-menu>
<mat-toolbar class="flexSpace" color="primary">
  {{ getTitle() }}

  <button
    [ngClass]="selectedClass"
    mat-flat-button
    [matMenuTriggerFor]="testAreas"
  >
    {{ selectedTestArea.toString() }}
  </button>
  <mat-menu style="display: flex; flex-direction: column" #testAreas="matMenu">
    <button
      *ngIf="user.hasEmbargoPermissions()"
      class="embargo"
      mat-menu-item
      (click)="selectTestArea(testArea.EMBARGO)"
    >
      {{ testArea.EMBARGO.toString() }}
    </button>
    <button
      class="pre-prod"
      mat-menu-item
      (click)="selectTestArea(testArea.PREPROD)"
    >
      {{ testArea.PREPROD.toString() }}
    </button>
    <button class="prod" mat-menu-item (click)="selectTestArea(testArea.PROD)">
      {{ testArea.PROD.toString() }}
    </button>
  </mat-menu>
</mat-toolbar>

<mat-card>
  <mat-card class="mat-elevation-z0 card-padding">
    <form [formGroup]="deploymentSetForm">
      <mat-form-field>
        <input
          type="text"
          matNativeControl
          placeholder="Enter Dynamic Image Set Id"
          label="Enter Dynamic Image Set Id"
          formControlName="deploymentSet"
          id="deploymentSetName"
          [matAutocomplete]="auto"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="selectedItem($event)"
        >
          <mat-option
            *ngFor="let option of filteredOptions | async"
            [value]="option"
          >
            {{ option }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </form>
  </mat-card>

  <mat-card-content *ngIf="isFormExpanded">
    <form [formGroup]="dynamicImageSetForm" (ngSubmit)="submitDis()">
      <mat-card class="mat-elevation-z0 card-padding">
        <mat-form-field>
          <mat-label>Select version</mat-label>
          <button mat-button (click)="previousVersion()">
            <mat-icon>arrow_drop_up</mat-icon>
          </button>
          <input
            type="text"
            placeholder="Pick one or type to filter"
            matInput
            formControlName="version"
            [matAutocomplete]="versionAuto"
            (dblclick)="clearVersion()"
          />
          <mat-autocomplete #versionAuto="matAutocomplete">
            <mat-option
              *ngFor="let version of filteredVersions | async"
              [value]="version.versionId + ' - ' + version.versionLabel"
              >{{ version.versionId }} - {{ version.versionLabel }}</mat-option
            >
          </mat-autocomplete>
          <button mat-button (click)="nextVersion()">
            <mat-icon>arrow_drop_down</mat-icon>
          </button>
        </mat-form-field>
      </mat-card>
      <mat-card class="mat-elevation-z0 card-padding">
        <mat-card-subtitle>Select viewport</mat-card-subtitle>
        <mat-radio-group formControlName="viewport">
          <mat-radio-button
            [disabled]="!availableViews.isExteriorValid"
            class="col-sm-2"
            id="exterior"
            value="exterior"
            >exterior</mat-radio-button
          >
          <mat-radio-button
            [disabled]="!availableViews.isInteriorValid"
            class="col-sm-2"
            id="interior"
            value="interior"
            >interior</mat-radio-button
          >
        </mat-radio-group>
      </mat-card>
      <mat-card
        class="mat-elevation-z0 card-padding"
        *ngIf="getTestDynamicType() == TestDynamicType.LAYERS"
      >
        <mat-card-subtitle>Select model</mat-card-subtitle>
        <mat-radio-group formControlName="model">
          <mat-radio-button
            class="col-sm-2"
            *ngFor="let v of models"
            id="{{ v }}"
            [value]="v"
            >{{ v }}</mat-radio-button
          >
        </mat-radio-group>
      </mat-card>
      <mat-card class="mat-elevation-z0 card-padding">
        <mat-form-field>
          <mat-label>Select resolution</mat-label>
          <mat-select formControlName="resolution">
            <mat-option
              *ngFor="let r of resolutions"
              [value]="r.resolutionName"
              >{{ r.resolutionName }}</mat-option
            >
          </mat-select>
        </mat-form-field>
      </mat-card>
      <mat-card class="mat-elevation-z0 card-padding">
        <mat-form-field>
          <mat-label>Select preview angles</mat-label>
          <mat-select formControlName="previewAngles" multiple>
            <mat-option *ngFor="let pAngle of previewAngles" [value]="pAngle">{{
              pAngle
            }}</mat-option>
          </mat-select>
        </mat-form-field>
      </mat-card>
      <mat-card class="mat-elevation-z0 d-flex justify-content-around">
        <button
          mat-raised-button
          color="primary"
          type="submit"
          [disabled]="
            dynamicImageSetForm.controls.version.invalid &&
            getTestDynamicType() == TestDynamicType.OPTIONS
            || (!availableViews.isExteriorValid && !availableViews.isInteriorValid)
          "
        >
          {{ getSubmitLabel() }}
        </button>
        <button
          mat-raised-button
          color="accent"
          type="reset"
          (click)="revert()"
        >
          Reset
        </button>
      </mat-card>
    </form>
  </mat-card-content>
</mat-card>

<div [ngSwitch]="getTestDynamicType()">
  <div *ngSwitchCase="TestDynamicType.LAYERS">
    <app-layers-tree-component
      *ngIf="showImagesAndTree"
      [dynamicImageSet]="dynamicImageSet"
      [id]="dynamicImageSet.id"
      [version]="dynamicImageSet.version"
      [viewport]="dynamicImageSet.viewport"
      [testArea]="selectedTestArea"
    ></app-layers-tree-component>
  </div>
  <div *ngSwitchCase="TestDynamicType.OPTIONS">
    <app-features-tree-component
      *ngIf="showImagesAndTree"
      [dynamicImageSet]="dynamicImageSet"
      [id]="dynamicImageSet.id"
      [version]="dynamicImageSet.version"
      [viewport]="dynamicImageSet.viewport"
      [testArea]="selectedTestArea"
    ></app-features-tree-component>
  </div>
  <div *ngSwitchDefault>
    <app-layers-tree-component
      *ngIf="showImagesAndTree"
      [dynamicImageSet]="dynamicImageSet"
      [id]="dynamicImageSet.id"
      [version]="dynamicImageSet.version"
      [viewport]="dynamicImageSet.viewport"
      [testArea]="selectedTestArea"
    ></app-layers-tree-component>
  </div>
</div>
